import React from 'react';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import LegacyWrapper from './components/LegacyWrapper';
import OAuthInstall from './oauth-install';
import ShopifyActivateCharge from './shopify/ShopifyActivateCharge';
import ShopifyOAuthInstall from './shopify/ShopifyOAuthInstall';
import { ToastInstall } from './toast/ToastInstall';

export const Routing = () => (
  <Router>
    <Routes>
      <Route
        path="/shopify/activate_charge"
        element={
          <LegacyWrapper>
            <ShopifyActivateCharge />
          </LegacyWrapper>
        }
      />

      <Route
        path="/install/shopify"
        element={
          <LegacyWrapper>
            <ShopifyOAuthInstall />
          </LegacyWrapper>
        }
      />

      <Route
        path="/shopify"
        element={
          <LegacyWrapper>
            <ShopifyOAuthInstall />
          </LegacyWrapper>
        }
      />

      {/* TODO not implemented yet

      this route will perform SSO if available, if not it will proceed with normal redirection
      THIS A IS PLATFORM SPECIFIC ENDPOINT */}
      {/* <Route path="/shopify/oauth/redirect" element={<ShopifyOauthRedirect />} /> */}

      {/* this route initiates OAuth process */}
      <Route
        path="/install/:platformName"
        element={
          <LegacyWrapper>
            <OAuthInstall />
          </LegacyWrapper>
        }
      />

      <Route path="/toast" element={<ToastInstall />} />

      {/**
      This route should be deprecated in the form it is currently defined (triggering installation process),
      but beware, as (at least) Shopify uses this endpoint for their needs.
      This route could be removed after updating all the relevant platforms.
      */}
      <Route
        path="/:platformName"
        element={
          <LegacyWrapper>
            <OAuthInstall />
          </LegacyWrapper>
        }
      />
    </Routes>
  </Router>
);
